import PromptDialog from "@entrilia/shared/components/dialog/PromptDialog.tsx";
import ReportGroupsConnector from "../../../../../report-lists/reports/components/ReportGroupsConnector.tsx";
import SaveReportFormWrapper from "../../../../../report-lists/reports/components/SaveReportFormWrapper.tsx";
import type { SaveAsDialogProps } from "../../../viewer/common/Types.ts";
import useSaveReportAsDialog from "../hooks/useSaveReportAsDialog.ts";

export default function SaveAsDialog({ report, addReport, onChanged, onClose }: SaveAsDialogProps) {
  const { error, handleSaveClicked, saving } = useSaveReportAsDialog({
    report,
    addReport,
    onChanged,
    onClose,
  });

  return (
    <PromptDialog open={true}>
      <ReportGroupsConnector clientCode={report.clientCode}>
        <SaveReportFormWrapper
          report={report}
          error={error}
          title={"Save As"}
          saveBtnTitle={"Save"}
          saving={saving}
          showName
          showLevel
          newReport
          onClose={onClose}
          onSave={handleSaveClicked}
        />
      </ReportGroupsConnector>
    </PromptDialog>
  );
}
